(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam-retro-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sam-retro-edit')) {
  customElements.define('sam-retro-edit', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.querySelector('[data-sam-filters]').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-sam-filter]');
        if (button) this.filter(button.dataset.samFilter);
      }, { signal: this.controller.signal });
      // Preload hover images away from the DOM: never show an old model while
      // Shopify's next variant image is downloading or decoding.
      const prepareLifestyle = (card, url) => {
        const lifestyle = card?.querySelector('[data-sam-lifestyle]');
        if (!lifestyle) return;
        const request = (Number(card.dataset.samHoverRequest || 0) + 1);
        card.dataset.samHoverRequest = String(request);
        lifestyle.hidden = true;
        lifestyle.removeAttribute('data-sam-hover-ready');
        if (!url) { lifestyle.removeAttribute('src'); return; }
        // Touch layouts never show hover photos; avoid downloading a second
        // image for every card through new Image() on mobile.
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        const candidate = new Image();
        candidate.decoding = 'async';
        candidate.onload = async () => {
          try { if (candidate.decode) await candidate.decode(); } catch (_) { /* onload is enough */ }
          if (!card.isConnected || card.dataset.samHoverRequest !== String(request)) return;
          lifestyle.src = url;
          lifestyle.dataset.samHoverReady = 'true';
          lifestyle.hidden = false;
        };
        candidate.onerror = () => { /* Keep hover hidden when the photo fails. */ };
        candidate.src = url;
      };
      this.querySelectorAll('[data-sam-product-card]').forEach(card => {
        const lifestyle = card.querySelector('[data-sam-lifestyle]');
        if (lifestyle) prepareLifestyle(card, lifestyle.getAttribute('src') || '');
      });
      // One stable preview path. No DOM scans, reflows or review-related work on swatch clicks.
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('button[data-sam-variant-image]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        const card = button.closest('[data-sam-product-card]');
        const link = card?.querySelector('.sam-card-image-link');
        const img = link?.querySelector('img.sam-card-image:not(.sam-card-image-hover)');
        if (!card || !link || !img) return;
        const variantUrl = button.dataset.samVariantUrl;
        if (variantUrl) {
          link.href = variantUrl;
          const titleLink = card.querySelector('.sam-card-meta h3 a');
          if (titleLink) titleLink.href = variantUrl;
        }
        for (const other of card.querySelectorAll('button[data-sam-variant-image]')) {
          other.setAttribute('aria-pressed', String(other === button));
        }
        // Keep lifestyle image attached to this color; never alter the main swatch logic.
        prepareLifestyle(card, button.dataset.samLifestyleUrl || '');
        // Some colors have no image assigned. Keep original picture rather than
        // searching the product gallery and accidentally displaying a model photo.
        const nextSrc = button.dataset.samVariantImage;
        if (!nextSrc) return;
        const nextSrcset = button.dataset.samVariantSrcset || '';
        if (img.getAttribute('src') === nextSrc) return;
        // Cancel previous pending preview: only the most recent click may win.
        const serial = (Number(card.dataset.samImageRequest || 0) + 1);
        card.dataset.samImageRequest = String(serial);
        const candidate = new Image();
        candidate.onload = () => {
          if (!card.isConnected || card.dataset.samImageRequest !== String(serial)) return;
          // Set srcset before src, otherwise Shopify responsive srcset can override src.
          if (nextSrcset) img.setAttribute('srcset', nextSrcset);
          else img.removeAttribute('srcset');
          img.setAttribute('src', nextSrc);
          link.dataset.samPreviewActive = 'true';
        };
        candidate.onerror = () => { /* Keep current image if variant file fails. */ };
        candidate.src = nextSrc;
      }, { signal: this.controller.signal });
      // Apps may inject review badges after load. Process in a bounded, debounced pass;
      // never let the observer react recursively to its own DOM moves.
      let reviewsScheduled = false;
      this.reviewObserver = new MutationObserver(records => {
        if (reviewsScheduled) return;
        const hasBadge = records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
          (node.matches?.('.jdgm-prev-badge, .jdgm-widget.jdgm-preview-badge, [class*="bk-review"], [class*="review-badge"], [class*="rating-badge"]') ||
            node.querySelector?.('.jdgm-prev-badge, .jdgm-widget.jdgm-preview-badge, [class*="bk-review"], [class*="review-badge"], [class*="rating-badge"]'))));
        if (!hasBadge) return;
        reviewsScheduled = true;
        queueMicrotask(() => {
          this.reviewObserver.disconnect();
          this.organizeReviews();
          reviewsScheduled = false;
          if (this.isConnected) this.reviewObserver.observe(this, { childList: true, subtree: true });
        });
      });
      this.organizeReviews();
      this.reviewObserver.observe(this, { childList: true, subtree: true });
      this.filterFromHash = () => {
        const match = location.hash.match(/^#sam-estilo-(aviador|ovaladas|cuadradas|y2k)$/);
        if (match) { this.filter(match[1]); this.scrollIntoView({ block: 'start' }); }
      };
      window.addEventListener('hashchange', this.filterFromHash, { signal: this.controller.signal });
      this.filterFromHash();
    }
    organizeReviews() {
      this.querySelectorAll('[data-sam-product-card]').forEach(card => {
        const target = card.querySelector('[data-sam-reviews]');
        if (!target) return;
        // External review apps can insert badges before the product name or in the swatch row.
        // Keep only one genuine badge in a dedicated row; preserve links to full reviews.
        const candidates = [...card.querySelectorAll('.jdgm-prev-badge, .jdgm-widget.jdgm-preview-badge, [class*="bk-review"], [class*="bk_reviews"], [class*="trustpilot-widget"], [class*="review-badge"], [class*="rating-badge"]')].filter(el => !el.closest('.sam-card-image-link') && !el.closest('[data-sam-reviews]') && !el.parentElement?.closest('.jdgm-prev-badge, .jdgm-widget.jdgm-preview-badge, [class*="bk-review"], [class*="review-badge"]'));
        const existing = target.querySelector('.sam-rating-native, .jdgm-prev-badge, .jdgm-widget, [class*="bk-review"], [class*="review-badge"], [class*="rating-badge"]');
        if (candidates.length && !existing) { target.append(candidates.shift()); }
        candidates.forEach(el => el.remove());
        // Some apps inject an unwrapped 'star rating' near the swatches; don't let it displace colors.
      });
    }
    filter(style) {
      let count = 0;
      this.querySelectorAll('[data-sam-style]').forEach(card => {
        card.hidden = style !== 'all' && card.dataset.samStyle !== style;
        if (!card.hidden) count += 1;
      });
      this.querySelectorAll('[data-sam-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.samFilter === style)));
      this.querySelector('[data-sam-note]').hidden = style !== 'all';
      const status = this.querySelector('[data-sam-status]');
      status.textContent = `${count} ${status.dataset.samCountLabel}`;
    }
    disconnectedCallback() { this.reviewObserver?.disconnect(); this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
